module.exports = __webpack_public_path__ + "img/Outdoors.f23c02c1.svg";